import { useTranslation } from 'react-i18next';

import useEvents from 'lib/hooks/useEvents';
import ExpandCollapseTap from 'lib/Tracking/Srp/SearchFilters/ExpandCollapseTap';
import { Features } from 'lib/EventSchema';
import { useAdvancedFilter } from 'lib/hooks/useSrpFilters';
import AdvancedTap from 'lib/Tracking/Srp/SearchFilters/AdvancedTap';

import FilterContainer from 'components/Shared/SearchFilter/FilterContainer';
import Toggle from 'components/Shared/SearchFilter/Toggle';

import { SrpAdvancedFilterName } from 'types/srpFilters';
import { useContext } from 'react';
import SrpEventContext from 'contexts/SrpEventContext';

export interface AdvancedFilterProps {
  expanded?: boolean;
}

export enum AdvancedOptions {
  hideOnlineListings = 'hideOnlineListings',
}

export default function AdvancedFilter({ expanded }: AdvancedFilterProps): JSX.Element {
  const logger = useEvents();
  const { sourcePage } = useContext(SrpEventContext);
  const { t } = useTranslation();
  const { value, setValue } = useAdvancedFilter();

  function handleChange(name: SrpAdvancedFilterName, isChecked: boolean): void {
    setValue({
      ...value,
      [name]: isChecked,
    });
  }

  function onClick(isExpanding: boolean): Promise<void> {
    return logger.log(ExpandCollapseTap({ feature: Features.advanced, isExpanding, sourcePage }));
  }

  return (
    <FilterContainer title={t('srp.filters.advanced.header')} expanded={expanded} onClick={onClick}>
      <div className="advanced-filter-inner-container">
        <Toggle
          label={t('srp.filters.advanced.hideOnlineListings')}
          id="hide-online-listings"
          isToggled={value.hideOnlineListings}
          onClick={(isChecked): void => {
            handleChange('hideOnlineListings', isChecked);
            logger.log(AdvancedTap(AdvancedOptions.hideOnlineListings, sourcePage));
          }}
        />
      </div>
      <style jsx>{`
        .advanced-filter-inner-container {
          padding-bottom: 8px;
        }
      `}</style>
    </FilterContainer>
  );
}
